import { render, staticRenderFns } from "./ZhiJi.vue?vue&type=template&id=4585205c&scoped=true&"
import script from "./ZhiJi.vue?vue&type=script&lang=js&"
export * from "./ZhiJi.vue?vue&type=script&lang=js&"
import style0 from "./ZhiJi.vue?vue&type=style&index=0&id=4585205c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585205c",
  null
  
)

export default component.exports